import { TheCollectionsType } from './components';
import { EditorialType } from './components/EditorialType/EditorialType';
import { ListingType } from './components/ListingType.tsx';
import type { HeroProductListingProps } from './types';

export const HeroProductListing = (props: HeroProductListingProps) => {
  const { headingNumberOfColoredWords, pageName, textBelowMedia, type } = props;

  if (type === 'editorial') {
    return <EditorialType {...props} />;
  }

  if (type === 'all the watches') {
    return (
      <ListingType
        {...props}
        data-test-id='HeroProductListingAllTheWatches'
        headingNumberOfColoredWords={headingNumberOfColoredWords}
        pageName='all'
        textBelowMedia={textBelowMedia}
      />
    );
  }

  if (type === 'all the straps') {
    return (
      <ListingType
        {...props}
        data-test-id='HeroProductListingAllTheStraps'
        headingNumberOfColoredWords={headingNumberOfColoredWords}
        pageName='all'
        textBelowMedia={textBelowMedia}
      />
    );
  }

  if (type === 'all the eyewear') {
    return (
      <ListingType
        {...props}
        data-test-id='HeroProductListingAllTheEyewear'
        headingNumberOfColoredWords={headingNumberOfColoredWords}
        pageName='all'
      />
    );
  }

  if (type === 'strap material') {
    return (
      <ListingType
        {...props}
        data-test-id='HeroProductListingStrapMaterial'
        headingNumberOfColoredWords={headingNumberOfColoredWords}
        textBelowMedia={textBelowMedia}
      />
    );
  }

  if (type === 'watch editorial page' && pageName === 'collections') {
    return (
      <TheCollectionsType
        {...props}
        data-test-id='HeroProductListingWatchEditorialCollections'
      />
    );
  }

  if (type === 'watch editorial page' && pageName !== 'collections') {
    return (
      <ListingType
        {...props}
        data-test-id='HeroProductListingWatchEditorial'
        headingNumberOfColoredWords={headingNumberOfColoredWords}
        textBelowMedia={textBelowMedia}
      />
    );
  }

  if (type === 'watch collection') {
    return (
      <ListingType
        {...props}
        data-test-id='HeroProductListingWatchCollection'
        headingNumberOfColoredWords={headingNumberOfColoredWords}
        type={type}
      />
    );
  }

  return null;
};
